'use client';

import React from 'react';
import { CheckSquare, Award, Clock, BookOpen } from 'lucide-react';
import Icon from '@/components/ui/AppIcon';


interface StatsRowProps {
  tasksComplete: number;
  totalTasks: number;
  assessmentsPassed: number;
  studyHours: number;
  weeksInProgress: number;
}

export default function StatsRow({ tasksComplete, totalTasks, assessmentsPassed, studyHours, weeksInProgress }: StatsRowProps) {
  const stats = [
    {
      id: 'stat-tasks',
      label: 'Tasks Done',
      value: tasksComplete,
      suffix: `/ ${totalTasks}`,
      icon: CheckSquare,
      color: 'var(--accent)',
    },
    {
      id: 'stat-assessments',
      label: 'Assessments Passed',
      value: assessmentsPassed,
      suffix: '/ 80',
      icon: Award,
      color: '#9B96F7',
    },
    {
      id: 'stat-hours',
      label: 'Study Hours',
      value: studyHours,
      suffix: 'hrs',
      icon: Clock,
      color: '#F0A64B',
    },
    {
      id: 'stat-inprogress',
      label: 'Weeks In Progress',
      value: weeksInProgress,
      suffix: '',
      icon: BookOpen,
      color: '#5BA8F5',
    },
  ];

  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(4, 1fr)',
        gap: '12px',
      }}
    >
      {stats.map(stat => {
        const Icon = stat.icon;
        return (
          <div
            key={stat.id}
            style={{
              backgroundColor: 'var(--bg-card)',
              border: '1px solid var(--border)',
              borderRadius: '10px',
              padding: '16px',
              display: 'flex',
              flexDirection: 'column',
              gap: '8px',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <span style={{ fontSize: '12px', color: 'var(--text-secondary)', fontWeight: 500 }}>
                {stat.label}
              </span>
              <Icon size={15} style={{ color: stat.color }} />
            </div>
            <div style={{ display: 'flex', alignItems: 'baseline', gap: '4px' }}>
              <span
                style={{
                  fontFamily: 'IBM Plex Mono, monospace',
                  fontSize: '24px',
                  fontWeight: 600,
                  color: 'var(--text-primary)',
                  fontVariantNumeric: 'tabular-nums',
                }}
              >
                {stat.value}
              </span>
              {stat.suffix && (
                <span style={{ fontSize: '12px', color: 'var(--text-muted)', fontFamily: 'IBM Plex Mono, monospace' }}>
                  {stat.suffix}
                </span>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}